export default __webpack_public_path__ + "static/ASLA_LiniaLounge_1-9c6d895d8f577ece31209339642a0b3a.png";